import { DealerUsersProps } from "store/modules/DealerUsers/types.store";

const cacheByDealerId = new Map<string, DealerUsersProps[]>();
const inflightByDealerId = new Map<string, Promise<DealerUsersProps[]>>();

export function getDealerDriversFromMemory(
  dealerId: string,
): DealerUsersProps[] | undefined {
  return cacheByDealerId.get(dealerId);
}

export function hasDealerDriversInMemory(dealerId: string): boolean {
  return cacheByDealerId.has(dealerId);
}

export function setDealerDriversInMemory(
  dealerId: string,
  drivers: DealerUsersProps[],
): void {
  cacheByDealerId.set(dealerId, drivers);
}

export function getDealerDriversInflight(
  dealerId: string,
): Promise<DealerUsersProps[]> | undefined {
  return inflightByDealerId.get(dealerId);
}

export function setDealerDriversInflight(
  dealerId: string,
  promise: Promise<DealerUsersProps[]>,
): void {
  inflightByDealerId.set(dealerId, promise);
}

export function clearDealerDriversInflight(dealerId: string): void {
  inflightByDealerId.delete(dealerId);
}

export function clearDealerDriversMemory(): void {
  cacheByDealerId.clear();
  inflightByDealerId.clear();
}
